import { CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS } from '@/app/utils/Collections';
import { FT_LIST } from '../FilterTypes';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
};

export default {
  category: CAT_SOCIAL_MEDIA_SCRAPER_CORE_ACCOUNTS,
  filters: [
    {
      id: 'platform',
      label: 'Platform',
      type: FT_LIST,
      group: groups.general,
      multiValues: false,
      getListItems: () => [
        {
          id: 'instagram',
          name: 'Instagram',
        },
        {
          id: 'facebook',
          name: 'Facebook',
        },
        {
          id: 'x',
          name: 'Twitter/X',
        },
        {
          id: 'youtube',
          name: 'YouTube',
        },
        {
          id: 'linkedin',
          name: 'LinkedIn',
        },
      ],
    },
    {
      id: 'status',
      label: 'Status',
      type: FT_LIST,
      group: groups.general,
      multiValues: false,
      getListItems: () => [
        {
          id: 'active',
          name: 'Active',
        },
        {
          id: 'inactive',
          name: 'Inactive',
        },
      ],
    },
  ],
};
